var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import { StyledNICWindow, StyledHeader } from '../styled';
var DraggableWindow = function (_a) {
    var children = _a.children, isWindowOpen = _a.isWindowOpen, position = _a.position, callTimer = _a.callTimer, holdTimer = _a.holdTimer;
    var _b = useDraggable({
        id: 'nic-window'
    }), attributes = _b.attributes, listeners = _b.listeners, setNodeRef = _b.setNodeRef, transform = _b.transform;
    var style = {
        transform: CSS.Translate.toString({
            x: position.x + ((transform === null || transform === void 0 ? void 0 : transform.x) || 0),
            y: position.y + ((transform === null || transform === void 0 ? void 0 : transform.y) || 0),
            scaleX: 1,
            scaleY: 1
        })
    };
    var headerText = callTimer
        ? "".concat(callTimer).concat(holdTimer ? " (On Hold: ".concat(holdTimer, ")") : '')
        : 'NIC';
    return (_jsxs(StyledNICWindow, { ref: setNodeRef, style: style, "$isWindowOpen": isWindowOpen, children: [_jsx(StyledHeader, __assign({}, attributes, listeners, { children: headerText })), children] }));
};
export default DraggableWindow;
